module.exports = __webpack_public_path__ + "img/9788970135410.295f6057.jpg";